export default __webpack_public_path__ + "assets/horizon.a471d7d5.svg";